import { SecurityInsightsBestPracticesCheckDetailsResponse } from '@cast/types';

import { useIsSecurityDemoMode } from '@cast/infrastructure-demo';

import { ExceptionsButton } from './ExceptionsButton';

type Props = {
  check?: SecurityInsightsBestPracticesCheckDetailsResponse;
};

export const CheckActions = ({ check }: Props) => {
  const isSecurityDemoMode = useIsSecurityDemoMode();

  if (!check || isSecurityDemoMode) {
    return null;
  }

  return <ExceptionsButton check={check} />;
};
